export default {
	sidebarToggleProperties: {
		isSideNavOpen: true,
		isSecondarySideNavOpen: false,
		isActiveSecondarySideNav: false,
	},
}
